import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const AdminDonationGroupModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default AdminDonationGroupModule;